// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__Vt_OL","main":"index_main__o1WUH","collapseContent":"index_collapseContent__wgOXm"};